<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import DashboardHint from '@/components/dashboard/ui/DashboardHint.vue'

/**
 * Claimable amount with the HMRC disclaimer hint beside it.
 * The figure is an estimate; HMRC uses the donor's tax record
 * to decide the relief they actually pay.
 */
const props = withDefaults(
  defineProps<{
    showHint?: boolean
    placement?: 'top' | 'bottom'
  }>(),
  {
    showHint: true,
    placement: 'top',
  }
)

const { t } = useI18n()
</script>

<template>
  <span class="sa-claim-amount-with-hint">
    <slot />
    <DashboardHint
      v-if="props.showHint"
      :placement="props.placement"
      :trigger-label="t('Dashboard.ClaimTaxBack.ClaimableHintTrigger')"
    >
      <p>{{ t('Dashboard.ClaimTaxBack.ClaimableHint') }}</p>
    </DashboardHint>
  </span>
</template>
